import * as Types from '@/types/schema';

import gql from 'graphql-tag';
import { PraiseDetailsFragmentDoc, PraisePostFragmentDoc, PraiseSkillRatingsFragmentDoc, PraiseMindsetRatingsFragmentDoc } from '../../fragments/generated/PraiseDetails';
import { UserFragmentDoc } from '../../../../../../../graphql/fragments/generated/User';
import { EntityMediaFragmentDoc } from '../../../../../../../features/messages/graphql/fragments/generated/MediaType';
import { PostReactionFragmentDoc } from '../../../../../../../features/reactions/graphql/fragments/generated/PostReaction';
import * as Urql from '@/utils/urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type UpdatePraiseMutationVariables = Types.Exact<{
  input: Types.UpdatePraiseInput;
}>;


export type UpdatePraiseMutation = { updatePraise?: { praise?: { id: string, visibleToEveryone: boolean, postId: string, createdAt: string, receiverUsers: Array<{ id: string, name?: string | null, firstName?: string | null, uniqueId: string, emailId?: string | null, profilePicture?: string | null, orgRole?: { id: string, name: string } | null }>, post?: { id: string, message: string, attachments?: Array<{ id: string, media: { name: string, description?: string | null, url?: string | null, size?: number | null, mimeType?: string | null, mediaId: string, kind: Types.MediaKindEnum, resolutions?: Array<{ type: Types.ResolutionEnum, url: string }> | null } }> | null, reactions?: Array<{ hasReacted?: boolean | null, reaction: string, count: number, userIds: Array<string>, users?: Array<{ id: string, name?: string | null, firstName?: string | null, uniqueId: string, emailId?: string | null, profilePicture?: string | null, orgRole?: { id: string, name: string } | null }> | null }> | null, mentions?: Array<{ entityId: string, entityType: Types.MentionEntityTypeEnum }> | null } | null, praiseChannel?: { id: string } | null, createdBy?: { id: string, name?: string | null, profilePicture?: string | null } | null, skillRatings?: Array<{ skillId: string, skill?: { id: string, name: string } | null }> | null, mindsetRatings?: Array<{ mindsetId: string, MindSet?: { id: string, name: string } | null }> | null } | null } | null };


export const UpdatePraiseDocument = /*#__PURE__*/ gql`
    mutation updatePraise($input: UpdatePraiseInput!) {
  updatePraise(data: $input) {
    praise {
      ...PraiseDetails
    }
  }
}
    ${PraiseDetailsFragmentDoc}
${UserFragmentDoc}
${PraisePostFragmentDoc}
${EntityMediaFragmentDoc}
${PostReactionFragmentDoc}
${PraiseSkillRatingsFragmentDoc}
${PraiseMindsetRatingsFragmentDoc}`;

export function useUpdatePraiseMutation() {
  return Urql.useMutation<UpdatePraiseMutation, UpdatePraiseMutationVariables>(UpdatePraiseDocument);
};